import React from 'react'
import { Link } from 'gatsby'
import styles from './DocHeader.module.css'
import logo from '../../assets/icon.png'

const DocHeader = ({ siteTitle }) => (
  <div className={styles.root}>
    <div className="navbar">
      <div className="navbar-section">
        <Link className="navbar-brand" to={'/'}>
          <img className={styles.logo} src={logo} alt="Logo" />
        </Link>
        <span className={styles.brand}>
          <Link to={'/docs'}>Suggested Documentation</Link>
        </span>
      </div>
      <div className="navbar-section">
        <Link className="btn btn-link" to={'/'}>
          Back to suggested.co
        </Link>
      </div>
    </div>
  </div>
)

export default DocHeader
